export default __webpack_public_path__ + "static/media/10t.ddf35825.jpg";